import { render } from "./TheSelectionLogistik.vue?vue&type=template&id=4206933f&scoped=true"
import script from "./TheSelectionLogistik.vue?vue&type=script&lang=js"
export * from "./TheSelectionLogistik.vue?vue&type=script&lang=js"

import "./TheSelectionLogistik.vue?vue&type=style&index=0&id=4206933f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4206933f"]])

export default __exports__